import axios from "axios";
import { createContext } from "react";
import { clearStorage } from "./storage";
import { API_URL } from "../../api/constants";
import { APP_URLS } from "../../api/apiUrls";
import { clearAuth } from "../User/userSlice";
import { store } from "./store";
import { clearCart } from "../Cart/cartSlice";
 
export const baseAxios = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 🔹 Delete user token API
const deleteUserToken = async (tokens) => {
  try {
    if (!tokens) throw new Error("Token missing");

    const { data } = await axios.post(
      APP_URLS.logoutUser(),
      {},
      {
        baseURL: API_URL,
        headers: {
          authorization: `Bearer ${tokens}`,
        },
      }
    );

    return data;
  } catch (err) {
    console.error("Logout failed:", err);
  }
};

// 🔹 Logout
export const logoutUser = async (tokens, skip = false) => {
  try {
    if (!skip) {
      await deleteUserToken(tokens);
    }
  } catch (e) {
    console.error("Ignore API error");
  } finally {
    store.dispatch(clearAuth());
    await clearStorage();
  }
};

// 🔹 Context
export const AxiosContext = createContext(null);